import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateComment, type CommentDTO } from '../services/api/comments';

export interface UpdateCommentVariables {
  taskId: number;
  commentId: number;
  body: string;
}

/**
 * Phase 25 Plan 25-05 — comment edit mutation.
 *
 * Wait-for-server (D-16); on success, invalidates ['comments', taskId] so
 * the list refetches with the fresh `updatedAt` (drives the `(edited)` tag).
 */
export function useUpdateComment() {
  const queryClient = useQueryClient();
  return useMutation<CommentDTO, Error, UpdateCommentVariables>({
    mutationFn: ({ taskId, commentId, body }) => updateComment(taskId, commentId, { body }),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['comments', vars.taskId] });
      // 260806-ddg — an edit can add new mentions, which auto-subscribe
      // those users as watchers; refresh the watchers panel.
      queryClient.invalidateQueries({ queryKey: ['tasks', vars.taskId, 'watchers'] });
    },
  });
}
